import React from 'react';
import { useWindowDimensions } from 'react-native';
import { LandscapeLoginScreenView } from './LandscapeLoginScreenView';
import { PortraitLoginScreenView } from './PortraitLoginScreenView';
import { LoginScreenViewProps } from './types';

export const LoginScreenView = (props: LoginScreenViewProps) => {
  const { width } = useWindowDimensions();

  return width >= 700 ? (
    <LandscapeLoginScreenView {...props} />
  ) : (
    <PortraitLoginScreenView {...props} />
  );
};
